import { Component, Input } from '@angular/core';

@Component({
  selector: 'wm-inspections-janus-action',
  standalone: false,
  templateUrl: './inspections-action-menu.component.html',
  styleUrls: ['./inspections-action-menu.component.scss']
})
export class InspectionsActionMenuComponent {
  @Input() row!: any;

  // Function callback for viewing details
  @Input() viewDetails!: (row: any) => void;

  onViewDetails(): void {
    this.viewDetails?.(this.row);
  }
}